import React from 'react';
import { calculateDuration, formatCurrency } from '../utils/helpers';

const TrainCard = ({ train, onSelect }) => {
  return (
    <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition border border-gray-200 overflow-hidden">
      <div className="p-6">
        {/* Train Header */}
        <div className="flex justify-between items-start mb-4">
          <div>
            <h3 className="text-xl font-bold text-primary">{train.trainName}</h3>
            <p className="text-sm text-gray-500">#{train.trainNumber}</p>
          </div>
          <div className="text-right">
            <p className="text-2xl font-bold text-accent">{formatCurrency(train.baseFare)}</p>
            <p className="text-xs text-gray-500">/person</p>
          </div>
        </div>

        {/* Journey Details */}
        <div className="flex items-center justify-between mb-4 pb-4 border-b">
          <div>
            <p className="text-lg font-semibold">{train.departureTime}</p>
            <p className="text-sm text-gray-600">{train.source}</p>
          </div>

          <div className="text-center flex-1 px-4">
            <p className="text-sm text-gray-600">
              {calculateDuration(train.departureTime, train.arrivalTime)}
            </p>
            <div className="h-px bg-gray-300 my-2"></div>
          </div>

          <div className="text-right">
            <p className="text-lg font-semibold">{train.arrivalTime}</p>
            <p className="text-sm text-gray-600">{train.destination}</p>
          </div>
        </div>

        {/* Availability */}
        <div className="flex items-center justify-between mb-4">
          <div>
            <p className="text-sm text-gray-600">Available Seats</p>
            <p className="text-lg font-bold text-green-600">{train.availableSeats}</p>
          </div>
          <div className="flex items-center space-x-2">
            <div className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm">
              Available
            </div>
          </div>
        </div>

        {/* Action Button */}
        <button
          onClick={() => onSelect(train)}
          className="w-full bg-primary text-white py-2 rounded-lg hover:bg-blue-700 transition font-semibold"
        >
          Select & Book
        </button>
      </div>
    </div>
  );
};

export default TrainCard;
